(function () {
	'use strict';

	/**
	 * @ngdoc component
	 *
	 * @name mx.shell:mxSidePanel
	 *
	 * @module mx.shell
	 * @requires {@ref mx.shell.SideLayout mx.shell.SideLayout}
	 * @requires {@ref mx.shell.SidePanelService mx.shell.SidePanelService}
	 * @requires {@ref mx.shell.DetailsView mx.shell.DetailsView}
	 * @requires {@ref mx.shell.EventService mx.shell.EventService}
	 * @requires {@ref mx.shell.HelpService mx.shell.ViewHelpService}
	 * @requires $scope
	 * @requires $timeout
	 *
	 * @description A panel, that shows actual information about current selected items,
	 * edit-forms and similar or wizards in separated tabs
	 *
	 * @usage <mx-side-panel></mx-side-panel>
	 */

	angular.module('mx.SolutionBuilderAgent').component('mxSidePanel', {
		controller: MxSidePanelCtrl,
		controllerAs: 'vm',
		templateUrl: 'workspaces/SolutionBuilderAgent/components/mx-side-panel/mx-side-panel.html',
	});

	MxSidePanelCtrl.$inject = [
		'mx.shell.SideLayout',
		'mx.shell.SidePanelService',
		'mx.shell.EventService',
		'$scope',
		'$timeout',
		'$element',
		'mx.shell.KeyboardNavigationService',
		'mx.internationalization',
		'mx.shell.AriaService',
	];

	function MxSidePanelCtrl(sideLayoutService, sidePanelService, eventService, $scope, $timeout, $element, keyboardNavigationService, i18n, ariaService) {
		var vm = this;

		vm.i18n = i18n.get('shell.common');

		vm.sideLayoutService = sideLayoutService;
		vm.sidePanelService = sidePanelService;

		vm.$onInit = function () {
			registerHotkeys();
			initAriaEvents();
		};

		var linkHelperShowTextEventHandler = eventService.subscribeTo(
			mx.shell.EventCodes.HelpShowText,
			function (e, elem) {
				if (elem) {
					vm.isMoreViewHelp = false;
					// showViewHelp(elem);
				}
			},
			$scope
		);

		$scope.$on('$destroy', function () {
			linkHelperShowTextEventHandler();
		});

		function registerHotkeys() {
			var invalidInputsSelector = ['.md-input-invalid input', 'mx-picker.ng-invalid input', '.mx-picker--invalid input'].join(',');

			keyboardNavigationService.registerKey({
				scope: $scope,
				key: 'alt+shift+n',
				hint: '⇧+n',
				description: 'Focus next invalid required input',
				callback: function () {
					var invalidInputs = $(invalidInputsSelector);
					var currentInput = invalidInputs.filter(':focus');
					var currentInputIndex = invalidInputs.index(currentInput);

					if (currentInputIndex === -1 || currentInputIndex === invalidInputs.length - 1) {
						invalidInputs.first().focus();
					} else {
						invalidInputs.eq(currentInputIndex + 1).focus();
					}
				},
			});

			keyboardNavigationService.registerKey({
				scope: $scope,
				key: 'alt+shift+p',
				hint: '⇧+p',
				description: 'Focus previous invalid required input',
				callback: function () {
					var invalidInputs = $(invalidInputsSelector);
					var currentInput = invalidInputs.filter(':focus');
					var currentInputIndex = invalidInputs.index(currentInput);

					if (currentInputIndex < 1) {
						invalidInputs.last().focus();
					} else {
						invalidInputs.eq(currentInputIndex - 1).focus();
					}
				},
			});

			keyboardNavigationService.registerKey([
				{
					scope: $scope,
					nameInTemplate: 'expandedHint',
					key: 'alt+shift+e',
					hint: '⇧+e',
					description: i18n.get('shell.mx-side-panel.expand'),
					callback: function () {
						$timeout(function () {
							vm.sideLayoutService.switchFullScreenMode();
						});
					},
				},
				{
					scope: $scope,
					key: 'alt+q',
					nameInTemplate: 'closeTabHint',
					description: i18n.get('shell.mx-side-panel.closeTab'),
					callback: function () {
						$timeout(function () {
							$('.mx-side-panel-content .mx-side-panel-close-button:visible').click();
						});
					},
				},
				/* {
				scope: $scope,
				key: 'alt+shift+q',
				nameInTemplate: 'closeAllTabsHint',
				hint: '⇧+q',
				description: i18n.get('shell.mx-side-panel.closeAllTabs'),
				callback: function () {
					$timeout(function() {
						$('.mx-side-panel-content .md-tab .mx-view-close:visible').click();
					});
				}
			},*/ {
					scope: $scope,
					key: 'alt+shift+d',
					hint: '⇧+d',
					description: i18n.get('shell.mx-side-panel.closePanel'),
					callback: function () {
						$timeout(function () {
							vm.sideLayoutService.hide();
						});
					},
				} /*{
				scope: $scope,
				key: 'alt+left',
				nameInTemplate: 'prevTab',
				description: i18n.get('shell.mx-side-panel.prevTab'),
				// OnRegister: function() {
				// 	$timeout(function() {
				// 		$('.mx-side-panel-content > md-tabs > md-tabs-wrapper .md-tab.md-active').attr('hint-key', '←→');
				// 	}, 500);
				// },
				callback: function () {
					$timeout(function() {
						$('.mx-side-panel-content > md-tabs > md-tabs-wrapper .md-tab.md-active:visible').prev().click();

						// $timeout(function() {
						// 	$('.mx-side-panel-content > md-tabs > md-tabs-wrapper .md-tab').attr('hint-key', null);
						// 	$('.mx-side-panel-content > md-tabs > md-tabs-wrapper .md-tab.md-active').attr('hint-key', '←→');
						// });
					});
				}
			}, {
				scope: $scope,
				key: 'alt+right',
				nameInTemplate: 'nextTab',
				description: i18n.get('shell.mx-side-panel.nextTab'),
				// OnRegister: function() {
				// 	$timeout(function() {
				// 		$('.mx-side-panel-content > md-tabs > md-tabs-wrapper .md-tab.md-active').attr('hint-key', '←→');
				// 	}, 500);
				// },
				callback: function () {
					$timeout(function() {
						$('.mx-side-panel-content > md-tabs > md-tabs-wrapper .md-tab.md-active:visible').next().click();

						// $timeout(function() {
						// 	$('.mx-side-panel-content > md-tabs > md-tabs-wrapper .md-tab').attr('hint-key', null);
						// 	$('.mx-side-panel-content > md-tabs > md-tabs-wrapper .md-tab.md-active').attr('hint-key', '←→');
						// }, 500);
					});
				}
			},*/ /* {
				scope: $scope,
				key: 'f2',
				nameInTemplate: 'showHelp',
				description: i18n.get('shell.mx-side-panel.showHelpLabel'),
				callback: function () {
					$timeout(function() {
						onClickShowViewHelp();
					});
				}
			}*/,
			]);
		}

		function initAriaEvents() {
			var moveFocusToDialog = () => {};
			var activeSidePanelTabSelector = '.active-tab mx-side-panel-tab-body';

			eventService.subscribeTo(
				mx.shell.EventCodes.SidePanelViewAdded,
				function (e, view) {
					moveFocusToDialog = ariaService.createPoliteFocusSettingFn(activeSidePanelTabSelector);
					if (view && view.dialogType === mx.SolutionBuilderAgent.ContentWidgetDialogAction.Preview) {
						ariaService.readMessage(i18n.get('solutionBuilderAgent.aria.loading-item'));
					}
				},
				$scope
			);

			[mx.SolutionBuilderAgent.Events.ViewDataLoaded, mx.shell.EventCodes.SidePanelCurrentViewChanged].forEach((event) =>
				eventService.subscribeTo(event, () => setTimeout(moveFocusToDialog, 500), $scope)
			);

			eventService.subscribeTo(
				mx.SolutionBuilderAgent.Events.ActionConfirmDialogCanceled,
				function () {
					setTimeout(function () {
						$(activeSidePanelTabSelector).focus();
					}, 10);
				},
				$scope
			);

			eventService.subscribeTo(
				mx.shell.EventCodes.SidePanelVisibility,
				function (e, visibility) {
					if (!visibility) {
						ariaService.readMessage(i18n.get('shell.aria.dialogHasBeenClosed'));
						moveFocusToDialog = () => {};
					}
				},
				$scope
			);

			$element.find('.mx-side-panel-tab--end').on('focus', function () {
				$element.find('.active-tab .mx-side-panel-tab-header--buttons-panel button:first').focus();
			});
		}
	}
})();
